export default __webpack_public_path__ + "static/media/my-web-platforms-white.fac5498b.svg";